module.exports = __webpack_public_path__ + "img/end.01318f76.png";